module.exports = __webpack_public_path__ + "img/icon_dzpcj.0687df5c.png";